<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#">{{translations('navbar.sale_management')}}</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">{{translations('order.archive_order')}}</li>
      </ol>
    </nav>
    <div class="container-fluid main-container">
      <div class="form-inline mb-4 justify-content-between">
        <div class="d-flex flex-wrap">
          <div class="form-group mr-2">
            <button class="btn btn-primary" type="button" data-toggle="modal" data-target="#ArchiveOrdersModal">{{translations('common.addition')}}</button>
          </div>
          <div class="form-group mr-1">
            <input id='dtSearch' type="text" class="form-control" v-model='dtSearch' :placeholder="translations('common.keyword_search')">
          </div>
          <div v-if="!checkBillingShow(status_id)" class="form-group mr-3">
            <v-select
              :value="master_billing.find(m => m.id === client_id) || ''"
              :options="master_billing"
              label="name"
              :placeholder="translations('order.billing_address')"
              :id="client_id"
              @input="changedMasterBilling">
            </v-select>
          </div>
          <div class="form-group mr-3 d-flex flex-wrap">
            <span class="mr-1">{{translations('common.period')}}</span>
<!--            <input v-model="dateFrom" type="date" class="form-control" @blur='triggerDateFilter("dateFrom")' @focus="tempDateField = dateFrom">-->
            <input v-model="dateFrom" type="date" class="form-control">
            <span class="mr-1 ml-1">〜</span>
<!--            <input v-model="dateTo" type="date" class="form-control" @blur='triggerDateFilter("dateTo")' @focus="tempDateField = dateTo">-->
            <input v-model="dateTo" type="date" class="form-control">
          </div>
          <div class="form-group mr-1">
            <div class="dropdown">
              <button id='filterByBilling' class="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                {{ getShipmentStatusTxt (translatedShipmentStatusList, status_id, 'name', translations('order.all_shipped')) }}
                </button>
              <div class="dropdown-menu">
                <a class='dropdown-item' v-for='(status, i) in translatedShipmentStatusList' :key='i' v-on:click='status_id=status.id'>{{ status.name }}</a>
              </div>
            </div>
          </div>
          <div v-if="checkShowWarehouse(status_id)" class="form-group mr-1">
            <div class="dropdown">
              <button id='filterByBilling' class="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                {{ getWarehouseFromName (warehousesFrom, warehouseFrom, 'name', this.translations('order.moved_from_warehouse')) }}
              </button>
              <div class="dropdown-menu">
                <a class='dropdown-item' v-for='(warehouse, i) in warehousesFrom' :key='i' v-on:click='warehouseFrom=warehouse.id'>{{ warehouse.name }}</a>
              </div>
            </div>
          </div>
          <div v-if="checkShowWarehouse(status_id)" class="form-group mr-1">
            <div class="dropdown">
              <button id='filterByBilling' class="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                {{ getWarehouseToName (warehousesTo, warehouseTo, 'name', this.translations('order.destination_warehouse')) }}
              </button>
              <div class="dropdown-menu">
                <a class='dropdown-item' v-for='(warehouse, i) in warehousesTo' :key='i' v-on:click='warehouseTo=warehouse.id'>{{ warehouse.name }}</a>
              </div>
            </div>
          </div>
          <div class="form-group ml-2">
            <div class="form-check">
              <input v-model="displayAll" class="form-check-input pointer-clickable" id="displayAll" type="checkbox" value="" >
              <label class="form-check-label pointer-clickable" for="displayAll">
                {{ translations('common.display_all') }}
              </label>
            </div>
          </div>
          <div class="form-group ml-2">
            <button class="btn btn-primary btn-sm" type="button" @click="submitSearch">{{translations('common.search')}}</button>
          </div>
        </div>
        <div class="form-inline justify-content-end" style="float:right;">
          <div class="form-group" style="margin: 1px 10px 0 0">
            <button class="btn btn-primary btn-sm" type="button" @click="exportCsv">{{translations('common.csv_export')}}</button>
          </div>
          <div class="form-group mr-3">
            <span class="font-weight-bold mb-0" style="font-size:15px;">{{translations('order.order_quantity')}}： {{ totalQuantity.toLocaleString() }}  </span>
          </div>
          <div class="form-group mr-3">
            <span class="font-weight-bold mb-0" style="font-size:15px;">{{translations('order.total_order_value')}}： {{ totalAmount.toLocaleString() }}  </span>
          </div>
          <div class="form-group">
            <span class="font-weight-bold mb-0" style="font-size:15px;">{{translations('order.gross_profit_total')}}： {{ (totalAmount-totalCost).toLocaleString() }}  </span>
          </div>
        </div>
      </div>
      <div class="table-scroll mb-4">
        <v-data-table
          class="table table-striped table-hover table-1500 table-clickable table-no-margin"
          item-key="name"
          :headers="translatedHeader"
          :items="orders"
          :options.sync="options"
          :server-items-length="totalCount"
          hide-default-footer
          @page-count="pageCount = $event"
        >
          <template v-slot:body="{ items }">
            <tbody class="nowrap">
              <template v-if="!isEmpty">
                <tr  v-for="(order, i) in items" :key='i' data-href="" @click="openSingleOrders(order)">
                  <td>{{i + 1}}</td>
                  <td>
                    <span class="badge" :class="getStatusClass(order.order_status, order.division_type)">
                      {{ getStatusLabel(order.order_status, order.division_type) }}
                    </span>
                  </td>
                  <td>{{ $invoiceTools.formatDate(order.order_at) }}</td>
                  <td>{{ order.order_number }}</td>
                  <td>
                    <ul v-if="!allShipNumbersEmpty(order.details)">
                      <li v-for="(detail, i) in order.details" :key="i">{{ detail.ship_number || '-' }}</li>
                    </ul>
                    <span v-else>-</span>
                  </td>
                  <td>{{ order.division_type === 'B' ? order.warehouseKaiShuFromName : order.client_name}}</td>
                  <td>
                    <ul>
                      <li v-for="(detail, i) in order.details" :key="i">{{detail.jan_code || '&nbsp;'}}</li>
                    </ul>
                  </td>
                  <td>
                    <ul>
                      <li v-for="(detail, i) in order.details" :key="i">{{detail.type_number || detail.omission_name || '&nbsp;'}}</li>
                    </ul>
                  </td>
                  <td class="right">
                    <ul>
                      <li v-for="(detail, i) in order.details" :key="i">{{detail.quantity.toLocaleString()}}</li>
                    </ul>
                  </td>
                  <td class="right">
                    <ul>
                      <li v-for="(detail, i) in order.details" :key="i">
                        <span v-if="Number(detail.tax_status) === 2">{{ detail.unit_price_inctax.toLocaleString() }}</span>
                        <span v-else>{{ detail.unit_price.toLocaleString() }}</span>
                      </li>
                    </ul>
                  </td>
                  <td class="right">
                    <ul>
                      <li v-for="(detail, i) in order.details" :key="i">{{detail.total_quantity_shipped.toLocaleString()}}</li>
                    </ul>
                  </td>
                  <td class="right">
                    <ul>
                      <li v-for="(detail, i) in order.details" :key="i">{{detail.remain_quantity.toLocaleString()}}</li>
                    </ul>
                  </td>
                  <td>
                    <ul>
                      <li v-for="(detail, i) in order.details" :key="i">{{detail.client_order_number || '&nbsp;'}}</li>
                    </ul>
                  </td>
                  <td>
                    <ul>
                      <li v-for="(detail, i) in order.details" :key="i">{{sliceNote(detail.internal_memo) || '&nbsp;'}}</li>
                    </ul>
                  </td>
                  <td class="right">{{ order.total_amount.toLocaleString() }}</td>
                  <td>{{ order.division_type === 'B' ? order.warehouseKaiShuName : order.destination_name}}</td>
                  <td>{{ sliceNote(order.note) }}</td>
                  <td>
                    <ul>
                      <li v-for="(detail, i) in order.details" :key="i">{{detail.remarks || '&nbsp;'}}</li>
                    </ul>
                  </td>
                  <td><DivisionTypeText :division_type="order.division_type" :labelDefault="null" /></td>
                  <td>{{ order.memo }}</td>
                </tr>
              </template>
              <template v-else>
                <tr class="odd">
                  <td valign="top" colspan="12" class="dataTables_empty">{{ isEmptyMsg }}</td>
                </tr>
              </template>
            </tbody>
          </template>
        </v-data-table>
      </div>
      <v-pagination v-model="page" :length="pageCount" :total-visible="11"></v-pagination>
    </div>
    <vue-element-loading :active="isSearching" :is-full-screen="true"/>
    <ArchiveOrdersModal @add="initList"/>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import ArchiveOrdersModal from '@/components/ArchiveOrdersModal'
import DivisionTypeText from '@/components/orders/DivisionTypeText'
import { DivisionType, OrderStatus } from '@/constants'
import { mapState } from 'vuex'
import { saveAs } from 'file-saver'
import Papa from 'papaparse'
import encoding from 'encoding-japanese'

export default {
  name: 'ArchiveOrders',
  props: {},
  components: {
    VueElementLoading,
    ArchiveOrdersModal,
    DivisionTypeText
  },
  data () {
    return {
      orders: [],
      client_id: 0,
      dtSearch: '',
      isSearching: false,
      isEmpty: false,
      isEmptyMsg: '',
      dateTo: '',
      dateFrom: '',
      // tempDateField: '',
      page: 1,
      pageCount: 0,
      totalCount: 0,
      totalAmount: 0,
      totalQuantity: 0,
      totalCost: 0,
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: false
      },
      status_id: 0,
      warehousesFrom: [],
      warehousesTo: [],
      warehouseFrom: 0,
      warehouseTo: 0,
      displayAll: false
    }
  },
  computed: {
    ...mapState(['currentLanguage']),
    master_billing () {
      return this.$store.getters['Master/getBillTo']
    },
    translatedShipmentStatusList () {
      const shipmentStatusList = [
        { id: 0, name: 'order.all_shipped' },
        { id: 2, name: 'order.shipped' },
        { id: 12, name: 'order.not_shipped' },
        { id: 1, name: 'order.not_ship' },
        { id: 3, name: 'order.partial_shipment' },
        { id: 11, name: 'order.backorder_management' },
        { id: 9, name: 'order.move' },
        { id: 10, name: 'order.moving' },
        { id: 5, name: 'order.move_completed' },
        { id: 4, name: 'order.display_all' }
      ]
      return shipmentStatusList.map(status => ({
        ...status,
        name: this.translations(status.name)
      }))
    },
    translatedHeader () {
      if (this.status_id === 3) {
        const headers = [
          { text: 'No', sortable: false },
          { text: 'order.order_status', value: 'order_status' },
          { text: 'order.order_date', value: 'ordered_at' },
          { text: 'order.order_number', value: 'order_number' },
          { text: 'sale.ship_number', value: 'ship_number' },
          { text: 'order.bill_to', value: 'younosuke_company_name' },
          { text: 'order.jan_code', value: 'jan_code' },
          { text: 'order.model', value: 'model' },
          { text: 'order.remaining_number_notes', value: 'quantity' },
          { text: 'order.unit_price', value: 'unit_price' },
          { text: 'order.shipped', value: 'total_quantity_shipped' },
          { text: 'order.remain_quantity', value: 'remain_quantity' },
          { text: 'order.client_order_number', value: 'client_order_number' },
          { text: 'order.product_internal_memo', value: 'internal_memo' },
          { text: 'order.total_amount', value: 'total_amount' },
          { text: 'order.destination_name', value: 'destination_name' },
          { text: 'order.internal_memo', value: 'note' },
          { text: 'order.summary', value: 'remarks' },
          { text: 'order.division', value: 'division_type' },
          { text: 'order.remarks', value: 'memo' }
        ]

        return headers.map(header => ({
          ...header,
          text: this.translations(header.text)
        }))
      } else {
        const headers = [
          { text: 'No', sortable: false },
          { text: 'order.order_status', value: 'order_status' },
          { text: 'order.order_date', value: 'ordered_at' },
          { text: 'order.order_number', value: 'order_number' },
          { text: 'sale.ship_number', value: 'ship_number' },
          { text: 'order.bill_to', value: 'younosuke_company_name' },
          { text: 'order.jan_code', value: 'jan_code' },
          { text: 'order.model', value: 'model' },
          { text: 'order.quantity', value: 'quantity' },
          { text: 'order.unit_price', value: 'unit_price' },
          { text: 'order.shipped', value: 'total_quantity_shipped' },
          { text: 'order.remain_quantity', value: 'remain_quantity' },
          { text: 'order.client_order_number', value: 'client_order_number' },
          { text: 'order.product_internal_memo', value: 'internal_memo' },
          { text: 'order.total_amount', value: 'total_amount' },
          { text: 'order.destination_name', value: 'destination_name' },
          { text: 'order.internal_memo', value: 'note' },
          { text: 'order.summary', value: 'remarks' },
          { text: 'order.division', value: 'division_type' },
          { text: 'order.remarks', value: 'memo' }
        ]

        return headers.map(header => ({
          ...header,
          text: this.translations(header.text)
        }))
      }
    }
  },
  watch: {
    // client_id () {
    //   this.initList()
    // },
    // status_id () {
    //   this.initList()
    // },
    page () {
      this.getFilterdList()
    },
    options: {
      handler () {
        let visitCount = Number(localStorage.getItem('visitCountOrders')) || 0
        if (visitCount > 0) {
          this.initList()
        }
      },
      deep: true
    }
  },
  created: function () {
    this.$store.dispatch('Master/checkBillTo')
    let storedFilter = this.$storage.get('ArchiveOrdersParam')
    this.listWarehouses()

    if (storedFilter) {
      this.dtSearch = storedFilter.search
      this.client_id = storedFilter.client_id
      this.dateFrom = storedFilter.start_at
      this.dateTo = storedFilter.end_at
      this.isShowShipped = storedFilter.show_shipped
      this.options.sortBy = storedFilter.orderbys
      this.options.sortDesc = storedFilter.is_descs
      this.status_id = storedFilter.status_id
    }
  },
  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    getStatusClass (status, divisionType) {
      if (Number(status) === OrderStatus.NOT_SHIPPED && divisionType === DivisionType[2].value) {
        return 'badge-info'
      } else if (Number(status) === OrderStatus.NOT_SHIPPED) {
        return 'badge-light'
      } else if (Number(status) === OrderStatus.SHIPPED) {
        return 'badge-success'
      } else if (Number(status) === OrderStatus.MOVED) {
        return 'badge-danger'
      } else if (Number(status) === OrderStatus.MOVE_RESERVED) {
        return 'badge-info'
      } else if (Number(status) === OrderStatus.MOVE_PARTIAL_RESERVED) {
        return 'badge-warning'
      }
      return 'badge-warning'
    },

    getStatusLabel (status, divisionType) {
      if (Number(status) === OrderStatus.NOT_SHIPPED && divisionType === DivisionType[2].value) {
        return this.translations('order.moving')
      } else if (Number(status) === OrderStatus.NOT_SHIPPED) {
        return this.translations('order.not_ship')
      } else if (Number(status) === OrderStatus.SHIPPED) {
        return this.translations('order.shipped')
      } else if (Number(status) === OrderStatus.MOVED) {
        return this.translations('order.move_completed')
      } else if (Number(status) === OrderStatus.MOVE_RESERVED) {
        return this.translations('order.reserved')
      } else if (Number(status) === OrderStatus.MOVE_PARTIAL_RESERVED) {
        return this.translations('order.partial_reservation')
      }
      return this.translations('order.partial_shipment')
    },

    getFilterTxt (obj, input, output, _default) {
      if (input) {
        if (input === 0) return _default
        return this.$invoiceTools.getObjPropsById(obj, input, output)
      }
      return _default
    },

    getShipmentStatusTxt (obj, input, output, _default) {
      if (input) {
        if (input === OrderStatus.ORTHER_SHIPPING) return _default
        return this.$invoiceTools.getObjPropsById(obj, input, output)
      }
      return _default
    },

    getWarehouseFromName (obj, input, output, _default) {
      if (input) {
        return this.$invoiceTools.getObjPropsById(obj, input, output)
      }
      return _default
    },

    getWarehouseToName (obj, input, output, _default) {
      if (input) {
        return this.$invoiceTools.getObjPropsById(obj, input, output)
      }
      return _default
    },

    // changeSearch (e) {
    //   console.log(e.target.value)
    //   this.$storage.set('ArchiveOrders:dtSearch', e.target.value) // KEEP KEYWORD
    //   this.initList()
    // },

    // triggerDateFilter (source) {
    //   if (source === 'dateFrom' && this.dateFrom !== this.tempDateField) {
    //     this.initList()
    //   }
    //
    //   if (source === 'dateTo' && this.dateTo !== this.tempDateField) {
    //     this.initList()
    //   }
    // },

    initList () {
      if (this.page !== 1) {
        this.page = 1
      } else {
        this.getFilterdList()
      }
    },

    getFilterdList () {
      if (this.displayAll) {
        this.$storage.set('order_display_all', this.displayAll)
        this.options.itemsPerPage = -1 // DISPLAY ALL
      } else {
        this.options.itemsPerPage = 10 // DISPLAY 10 ROWS
      }

      if (this.isSearching) {
        return
      }

      this.isSearching = true

      const offset = (this.page - 1) * this.options.itemsPerPage
      const limit = this.options.itemsPerPage
      const orderbys = JSON.parse(JSON.stringify(this.options.sortBy))
      const isDescs = JSON.parse(JSON.stringify(this.options.sortDesc))

      let warehouseFrom = 0
      let warehouseTo = 0
      if (this.status_id === OrderStatus.ORTHER_SHIPPING || this.status_id === OrderStatus.MOVE ||
        this.status_id === OrderStatus.MOVING || this.status_id === OrderStatus.MOVED || this.status_id === OrderStatus.ALL) {
        warehouseFrom = this.warehouseFrom
        warehouseTo = this.warehouseTo
      }

      this.client_id = this.status_id === OrderStatus.MOVE || this.status_id === OrderStatus.MOVING || this.status_id === OrderStatus.MOVED ? 0 : this.client_id

      let params = {
        client_id: this.client_id,
        start_at: this.dateFrom,
        end_at: this.dateTo,
        offset: offset,
        limit: limit,
        orderbys: orderbys,
        is_descs: isDescs,
        search: this.dtSearch,
        status_id: this.status_id,
        warehouse_from: warehouseFrom,
        warehouse_to: warehouseTo
      }

      this.$storage.set('ArchiveOrdersParam', params)
      console.log('ArchiveOrders:getFilterdOrderList: ', params)

      return this.$http.post(this.$api_url.orders_list, params).then(response => {
        const result = response.data
        if (result.status === true) {
          this.isEmpty = false
          this.isEmptyMsg = ''
          this.orders = result.list
          localStorage.setItem('visitCountOrders', this.orders.length)
          this.totalCount = Number(result.total_count)
          this.totalAmount = Number(result.total_amount)
          this.totalQuantity = Number(result.total_quantity)
          this.totalCost = Number(result.total_cost)
        } else {
          this.orders = []
          this.$toastr.error(result.message, this.translations('common.error'))
        }
      }).catch(e => {
        console.log('ArchiveOrders:API:getFilterdList: error: ', e)
        this.isEmpty = true
        this.isEmptyMsg = this.translations('order.notice_failed')
        this.$toastr.error(this.isEmptyMsg, this.translations('common.error'))
      }).finally(() => {
        this.isSearching = false
        this.$nextTick(() => {
          this.$vuetify.goTo('.table-scroll', { duration: 0 })
        })
      })
    },

    async listWarehouses () {
      try {
        let { data } = await this.$http.post(`${this.$api_url.warehouse_list}?typeB=true`)
        if (data.status === true) {
          this.warehousesFrom = [ ...data.list, { id: 0, name: '移動元倉庫' } ]
          this.warehousesTo = [ ...data.list, { id: 0, name: '移動先倉庫' } ]
          this.warehousesFrom.sort((a, b) => a.id - b.id)
          this.warehousesTo.sort((a, b) => a.id - b.id)
        } else {
          this.warehousesFrom = [{ id: 0, name: 'No record.' }]
          this.warehousesTo = [{ id: 0, name: 'No record.' }]
        }
      } catch (error) {
        this.$toastr.error(this.translations('order.notice_failed'), this.translations('common.error'))
      }
    },

    openSingleOrders (order) {
      this.$router.push({ name: 'single-orders', query: { orders_id: order.orders_id, status_id: this.status_id } })
    },

    changedMasterBilling (event) {
      if (!event) {
        this.client_id = 0
        return
      }
      this.client_id = event.id
    },

    checkBillingShow (statusId) {
      return statusId === OrderStatus.MOVE || statusId === OrderStatus.MOVING || statusId === OrderStatus.MOVED
    },

    checkShowWarehouse (statusId) {
      return statusId === OrderStatus.MOVE || statusId === OrderStatus.MOVING ||
      statusId === OrderStatus.MOVED || statusId === OrderStatus.ALL
    },

    sliceNote (note) {
      let text = ''
      if (note) {
        let noteLength = note.length
        text = noteLength > 15 ? note.slice(0, 15) + '.....' : note
      }
      return text
    },

    submitSearch () {
      this.initList()
    },

    allShipNumbersEmpty (orderDetail) {
      return orderDetail.every(detail => !detail.ship_number)
    },

    exportCsv () {
      if (this.isSearching) {
        return
      }
      this.isSearching = true
      let warehouseFrom = 0
      let warehouseTo = 0
      if (this.status_id === OrderStatus.ORTHER_SHIPPING || this.status_id === OrderStatus.MOVE ||
        this.status_id === OrderStatus.MOVING || this.status_id === OrderStatus.MOVED || this.status_id === OrderStatus.ALL) {
        warehouseFrom = this.warehouseFrom
        warehouseTo = this.warehouseTo
      }

      this.client_id = this.status_id === OrderStatus.MOVE || this.status_id === OrderStatus.MOVING || this.status_id === OrderStatus.MOVED ? 0 : this.client_id

      let params = {
        client_id: this.client_id,
        start_at: this.dateFrom,
        end_at: this.dateTo,
        search: this.dtSearch,
        status_id: this.status_id,
        warehouse_from: warehouseFrom,
        warehouse_to: warehouseTo,
        reserve: false
      }

      return this.$http.post(this.$api_url.orders_csv, params).then(response => {
        const result = response.data
        if (result.status) {
          this.saveCsv_(result.list)
        }
      }).catch(e => {
        this.isEmpty = true
        this.isEmptyMsg = 'エラーのため失敗しました。ご確認後、再試行してください。'
        this.$toastr.error(this.isEmptyMsg, 'エラー')
      }).finally(() => {
        this.isLoading = false
      })
    },

    saveCsv_ (list) {
      const data = []
      list.forEach(item => {
        const divisionTypeObj = DivisionType.find(type => type.value === item.division_type)
        item.details.forEach(detail => {
          data.push([
            this.getStatusLabel(item.order_status, item.division_type),
            item.order_at,
            item.order_number,
            item.ship_number,
            item.client_name,
            detail.jan_code,
            detail.type_number,
            detail.quantity,
            detail.unit_price,
            detail.total_quantity_shipped,
            detail.remain_quantity,
            detail.client_order_number,
            detail.internal_memo,
            item.total_amount,
            item.destination_name,
            item.note,
            detail.remarks,
            divisionTypeObj ? divisionTypeObj.label : '',
            item.memo
          ])
        })
      })
      let csv = ''
      csv = Papa.unparse({
        fields: [
          this.translations('order.order_status'),
          this.translations('order.order_date'),
          this.translations('order.order_number'),
          this.translations('sale.ship_number'),
          this.translations('order.bill_to'),
          this.translations('order.jan_code'),
          this.translations('order.model'),
          this.translations('order.quantity'),
          this.translations('order.unit_price'),
          this.translations('order.shipped'),
          this.translations('order.remain_quantity'),
          this.translations('order.client_order_number'),
          this.translations('order.product_internal_memo'),
          this.translations('order.total_amount'),
          this.translations('order.destination_name'),
          this.translations('order.internal_memo'),
          this.translations('order.summary'),
          this.translations('order.division'),
          this.translations('order.remarks')
        ],
        data: data
      })
      const unicodeList = encoding.stringToCode(csv)
      const sjisArray = encoding.convert(unicodeList, 'SJIS', 'UNICODE')
      const uInt8List = new Uint8Array(sjisArray)
      const content = new Blob([uInt8List], { type: 'text/csv' })
      const d = new Date()
      const filename = this.translations('order.order_') + d.getFullYear() +
        ('0' + (d.getMonth() + 1)).slice(-2) +
        ('0' + d.getDate()).slice(-2) + '_' +
        ('0' + d.getHours()).slice(-2) +
        ('0' + d.getMinutes()).slice(-2) +
        ('0' + d.getSeconds()).slice(-2) + '.csv'
      saveAs(content, filename)
      this.isSearching = false
    }
  }
}
</script>

<style>
#tbl-orders_wrapper .col-sm-12{
  padding-right: 0 !important;
}
</style>
